import { render, staticRenderFns } from "./PerformanceSummaryComponent.vue?vue&type=template&id=8053e612&scoped=true"
import script from "./PerformanceSummaryComponent.js?vue&type=script&lang=js&external"
export * from "./PerformanceSummaryComponent.js?vue&type=script&lang=js&external"
import style0 from "./PerformanceSummaryComponent.vue?vue&type=style&index=0&id=8053e612&prod&scoped=true&lang=css"
import style1 from "./PerformanceSummaryComponent.vue?vue&type=style&index=1&id=8053e612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8053e612",
  null
  
)

export default component.exports